module.exports = __webpack_public_path__ + "static/media/vidIconPng.8696db3a.png";